import { Component, ojs, app, payload } from "modular-openscriptjs";
import { dom } from "../../fotastart";
import { either, empty } from "../../helpers";
import { $e } from "../../ojs.events";

const h = app("h");
const dc = app("dc");

export default class SearchBar extends Component {
    render(...args) {
        let query = dc.searchQuery ?? "";

        if(empty(query)) {
            query = app("router").qs.get("ks") ?? "";
        }

        return h.div(
            {
                class: "search-bar-container w-100",
            },
            // Mobile: Grouped (Button Hidden)
            h.div(
                {
                    class: "input-group rounded-pill overflow-hidden border border-2 shadow-sm d-flex d-md-none transition-all bg-white",
                },
                either(app("router").is("app.search"), {
                    class: "border-primary",
                }),
                h.span(
                    {
                        class: "input-group-text bg-transparent border-0 ps-3 text-muted",
                    },
                    h.i({ class: "bi bi-search" }),
                ),
                h.input(
                    {
                        type: "search",
                        class: "form-control border-0 px-2 bg-transparent shadow-none",
                        placeholder: "Search inventory...",
                        style: "height: 40px;",
                        hook: "mobile_search_input",
                        value: query,
                        listeners: {
                            click: function () {
                                if (dc.searchType === "services" && app("router").is("business.services.view")) {
                                    // Already on the services page, do nothing here
                                } else if (!app("router").is("app.search")) {
                                    app("router").to("app.search");
                                }
                            },
                            input: function (e) {
                                dc.searchQuery = e.target.value;
                                app("broker").send(
                                    $e.system.needs.search,
                                    payload({
                                        query: dc.searchQuery,
                                    }),
                                );
                            },
                        },
                    },
                    either(app("router").is("app.search"), {
                        autofocus: true,
                    }),
                ),
            ),

            // Desktop: Separate
            h.div(
                {
                    class: "d-none d-md-flex align-items-center gap-2",
                },
                h.div(
                    {
                        class: "input-group rounded-pill border shadow-sm overflow-hidden transition-all flex-grow-1",
                    },
                    either(app("router").is("app.search"), {
                        class: "border-primary border-2",
                    }),
                    h.span(
                        {
                            class: "input-group-text bg-transparent border-0 ps-3 text-muted",
                        },
                        h.i({ class: "bi bi-search" }),
                    ),
                    h.input(
                        {
                            type: "search",
                            class: "form-control border-0 px-2 bg-transparent shadow-none",
                            placeholder: "Search inventory...",
                            style: "height: 40px;",
                            value: query,
                            listeners: {
                                click: function () {
                                    if (dc.searchType === "services" && app("router").is("business.services.view")) {
                                        // Already on the services page, do nothing here
                                    } else if (!app("router").is("app.search")) {
                                        app("router").to("app.search");
                                    }
                                },
                                input: function (e) {
                                    dc.searchQuery = e.target.value;
                                    app("broker").send(
                                        $e.system.needs.search,
                                        payload({
                                            query: dc.searchQuery,
                                        }),
                                    );
                                },
                            },
                        },

                        either(app("router").is("app.search"), {
                            autofocus: true,
                        }),
                    ),
                ),
                h.button(
                    {
                        class: "btn btn-primary rounded-pill px-4 fw-bold shadow-sm",
                        type: "button",
                        style: "height: 40px;",
                        hook: "search_button",
                        listeners: {
                            click: function () {
                                if (dc.searchType === "services" && app("router").is("business.services.manage")) {
                                    // Already on the services page
                                    app("broker").send(
                                        $e.system.needs.search,
                                        payload({ query: dc.searchQuery })
                                    );
                                } else if (!app("router").is("app.search")) {
                                    app("router").to("app.search");
                                }
                            },
                        },
                    },
                    "Search",
                ),
            ),
            ...args,
        );
    }
}

ojs(SearchBar);
